import { __decorate } from "tslib";
import RoomSensors from '../components/RoomSensors.vue';
import { QBtn, QBtnGroup, QBtnToggle, QPageSticky, QSpace, QTooltip } from 'quasar';
import SensorGraph from '../components/SensorGraph.vue';
import { ESensor, ESetPoint, ETimeFrame } from '@sicfe/rooms/types';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
let RoomDetails = class RoomDetails extends Vue {
    constructor() {
        super(...arguments);
        this.zoomValues = {
            min: undefined,
            max: undefined,
        };
        this.datasource = {
            timeframe: ETimeFrame.DAY,
            to: 0,
            from: -1,
        };
    }
    get graphOrder() {
        let m = {
            [ESensor.Temperature]: null,
            [ESensor.CO2]: {
                merge: [ESensor.Flow],
                group: [ESensor.VOC],
            },
            [ESensor.Motion]: null,
            [ESensor.CurrentPower]: {
                group: [ESensor.CurrentPowerPhase, ESensor.TotalPower, ESensor.TotalPowerPhase],
            },
            [ESensor.Humidity]: null,
            [ESensor.Pressure]: null,
            [ESensor.Voltage]: {
                group: [ESensor.Current],
            },
            [ESensor.TotalGas]: null,
            [ESensor.CurrentWaterFlow]: {
                group: [ESensor.TotalWater],
            },
        };
        if (this.showSetpoints || this.debug) {
            m = {
                [ESensor.Temperature]: {
                    merge: [ESetPoint.MinTemperature, ESetPoint.MaxTemperature],
                    group: [ESetPoint.TemperatureMode],
                },
                [ESensor.CO2]: {
                    merge: [ESensor.Flow, ESetPoint.VentilationFlowSetpoint],
                    group: [ESensor.VOC, ESetPoint.ValveFlowPercentageSetpoint],
                },
                [ESensor.Motion]: null,
                [ESensor.CurrentPower]: {
                    group: [ESensor.CurrentPowerPhase, ESensor.TotalPower, ESensor.TotalPowerPhase],
                },
                [ESetPoint.LightSetpoint]: {
                    group: [ESetPoint.PowerSetpoint],
                },
                [ESensor.Humidity]: null,
                [ESensor.Pressure]: null,
                [ESensor.Voltage]: {
                    group: [ESensor.Current],
                },
                [ESensor.TotalGas]: null,
                [ESensor.CurrentWaterFlow]: {
                    group: [ESensor.TotalWater],
                },
            };
            if (this.debug) {
                m[ESetPoint.LightSetpoint].group.push(ESensor.RelayState);
                m[ESensor.CO2].group.push(ESensor.ValveFlowPercentage);
            }
        }
        return m;
    }
    setZoom(event) {
        this.zoomValues.min = event.userMin;
        this.zoomValues.max = event.userMax;
    }
    resetZoom() {
        this.zoomValues = {
            min: undefined,
            max: undefined,
        };
    }
    get timeframes() {
        return Object.values(ETimeFrame).map((value) => {
            return {
                value: value,
                label: this.$t(`sharedText.terms.${value}`).toString(),
            };
        });
    }
    clearFromToAndZoom() {
        this.resetZoom();
        this.datasource = {
            timeframe: this.datasource.timeframe,
            from: -1,
            to: 0,
        };
    }
    nextTimeframe() {
        if (this.datasource.to === 0)
            return;
        this.resetZoom();
        this.datasource = {
            timeframe: this.datasource.timeframe,
            from: this.datasource.from + 1,
            to: this.datasource.to + 1,
        };
    }
    prevTimeframe() {
        this.resetZoom();
        this.datasource = {
            timeframe: this.datasource.timeframe,
            from: this.datasource.from - 1,
            to: this.datasource.to - 1,
        };
    }
};
__decorate([
    Prop({ required: true, type: Object })
], RoomDetails.prototype, "room", void 0);
__decorate([
    Prop({ required: true })
], RoomDetails.prototype, "sensorDataGetter", void 0);
__decorate([
    Prop({ required: false })
], RoomDetails.prototype, "keyPrefix", void 0);
__decorate([
    Prop({ required: false, type: Boolean, default: false })
], RoomDetails.prototype, "showSetpoints", void 0);
__decorate([
    Prop({ required: false, type: Boolean, default: true })
], RoomDetails.prototype, "debug", void 0);
__decorate([
    Watch('datasource.timeframe')
], RoomDetails.prototype, "clearFromToAndZoom", null);
RoomDetails = __decorate([
    Component({
        components: {
            QBtnGroup,
            QBtn,
            QBtnToggle,
            QPageSticky,
            QSpace,
            QTooltip,
            RoomSensors,
            SensorGraph,
        },
    })
], RoomDetails);
export default RoomDetails;
